import { Pipe, PipeTransform } from "@angular/core";
import { RequestSourceTypeEnum } from "../models/request";

@Pipe({
  name: "isWorkorderRequest",
  pure: true,
})
export class IsWorkorderRequestPipe implements PipeTransform {
  transform(requestSource: RequestSourceTypeEnum, args?: any): boolean {
    return requestSource === RequestSourceTypeEnum.workorderRequest;
  }
}
